import { __awaiter } from "tslib";
export const fetchWrapper = (...args) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield fetch(...args);
    return response;
});
